import { lazy } from "react";
import { BASE_PATH } from "context/SiteSettingsContext/utils";
import { ERouteMappingKeys } from "./routeKeys";

export const wifiRoutes = {
  [ERouteMappingKeys.WIFI]: {
    id: "wifi",
    path: "/wifi",
    components: {
      [BASE_PATH]: lazy(() =>
        import("pages/Sections/WiFi/Overview").then((p) => ({
          default: p.Overview,
        })),
      ),
      flagship: lazy(() =>
        import("pages/Sections/WiFi/Flagship").then((p) => ({
          default: p.Flagship,
        })),
      ),
      enterprise: lazy(() =>
        import("pages/Sections/WiFi/Enterprise").then((p) => ({
          default: p.WiFiEnterprise,
        })),
      ),
      wall: lazy(() =>
        import("pages/Sections/WiFi/Wall").then((p) => ({
          default: p.Wall,
        })),
      ),
      outdoor: lazy(() =>
        import("pages/Sections/WiFi/Outdoor").then((p) => ({
          default: p.Outdoor,
        })),
      ),
      bridging: lazy(() =>
        import("pages/Sections/WiFi/Bridging/Bridging").then((p) => ({
          default: p.Bridging,
        })),
      ),
    },
  },
};
